module.exports = __webpack_public_path__ + "img/MAMA_GABY.b003d676.png";